import axios from "@/api/axiosInstance";
import { DeleteCatalogCategoryResponse } from "./types";

export const deleteCatalogCategory = async (
  id: string,
): Promise<DeleteCatalogCategoryResponse> => {
  const response = await axios.delete<DeleteCatalogCategoryResponse>(
    `/api/private/product-catalog/categories/${id}`,
  );
  return response.data;
};
